module.exports = __webpack_public_path__ + "img/user-edit.396d4ac8.svg";